import React from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { Footer } from "./components/footer";
import { TopNav } from "./components/top-nav";
import { NavPath } from "./enums/nav";
import { About } from "./pages/about";
import { Research } from "./pages/research";
import { Guidelines } from "./pages/guidelines";
import { Home } from "./pages/home";
import { Design } from "./pages/design";

export interface IDesktopLayoutProps {
    currNav: string;
    currAnchor: string;
    handleNavClick: (navItem: string) => void;
    handleMenuClick: (anchor: string) => void;
    childComponentDidMount: (anchorList: string[]) => void;
}

export function DesktopLayout(props: IDesktopLayoutProps) {
    return (
        <Router>
            <TopNav
                selected={props.currNav}
                handleNavClick={props.handleNavClick}
            />
            <Switch>
                <Route path={NavPath.ABOUT}>
                    <About
                        showAnchorMenu={true}
                        currAnchor={props.currAnchor}
                        handleMenuClick={props.handleMenuClick}
                        onComponentMounted={props.childComponentDidMount}
                    />
                </Route>
                <Route path={NavPath.DESIGN}>
                    <Design
                        showAnchorMenu={true}
                        currAnchor={props.currAnchor}
                        handleMenuClick={props.handleMenuClick}
                        handleNavClick={props.handleNavClick}
                        onComponentMounted={props.childComponentDidMount}
                    />
                </Route>
                <Route path={NavPath.RESEARCH}>
                    <Research
                        showAnchorMenu={true}
                        currAnchor={props.currAnchor}
                        handleMenuClick={props.handleMenuClick}
                        handleNavClick={props.handleNavClick}
                        onComponentMounted={props.childComponentDidMount}
                    />
                </Route>
                <Route path={NavPath.GUIDELINES}>
                    <Guidelines
                        showAnchorMenu={true}
                        currAnchor={props.currAnchor}
                        handleMenuClick={props.handleMenuClick}
                        handleNavClick={props.handleNavClick}
                        onComponentMounted={props.childComponentDidMount}
                    />
                </Route>
                <Route path={NavPath.HOME}>
                    <Home
                        showAnchorMenu={true}
                        currAnchor={props.currAnchor}
                        handleMenuClick={props.handleMenuClick}
                        handleNavClick={props.handleNavClick}
                        onComponentMounted={props.childComponentDidMount}
                    />
                </Route>
            </Switch>
            <Footer />
        </Router>
    );
}